<template>
    <div>
        <eco-header :step_num="2" />
        <b-row>
            <b-col>

            </b-col>
        </b-row>
        <b-row v-if="showCompany">
            <b-col>
                <b-spinner v-if='spinner' small label="Loading..."></b-spinner>
                <eco-company-view
                    :company.sync="company" 
                    :items="items" 
                    :editable="true" 
                    :allowNextStep.sync="allowNext"
                    @updateStore="updateStore"/>
            </b-col>
        </b-row>
        <eco-footer :step_num="2" :allow_next="allowNext"/>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            allowNext: false,
            spinner: false,
            company: null,
            items: [
                '5*opf.full', '2*opf.short', 
                '2*name.full', '2*name.short', 
                '10*id.inn', 'id.kpp', '13*id.ogrn', '8*id.date', 'id.okved',
                'ceo.post', 'ceo.name'
            ]
        }
    },
    mounted() {
        if(this.$store.getters.COMPANY) {
            this.company = this.$store.getters.COMPANY
        } else {
            this.loadCompany()
        }
    },
    methods: {
        updateStore() { this.$store.dispatch('COMPANY', this.company) },
        loadCompany() {
            this.spinner = true
            axios.get(`${window.$apiurl}/empty`)
            .then(res => {
                if(res.data.status === 'ok') {
                    this.$store.dispatch('COMPANY', res.data.data)
                    this.company = this.$store.getters.COMPANY
                } else window.$showError(this, res.data)                  
                this.spinner = false
            })
            .catch(err => window.$showError(this, err))
        }
    },
    computed: {
        showCompany() { return this.$store.getters.COMPANY ? true : false }
    }
}
</script>